module.exports = function(gsap) {

    const banners = document.querySelectorAll('.sc-banner:not(.sc-banner--disable-parallax) img, .sc-get-in-touch img');

    banners.forEach((banner, index) => {
        if ( banner ) {
            gsap.to(banner, {
                scrollTrigger: {
                    trigger: banner,
                    start: 'top bottom-=25%',
                    scrub: true
                },
                yPercent: -20,
            })
        }
    })

};